/**
 * Replaces bracket notation in a path string with dot notation.
 *
 * For example, converts "foo[0].bar[1]" to "foo.0.bar.1".
 *
 * @param path - The input string containing bracket notation.
 * @returns The path string with bracket notation replaced by dot notation.
 */
export const replacePath = (path: string): string => {
  return path.replace(/\[(\w+)\]/g, '.$1');
};
